import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { setFilteredEtabActivetedWebService } from "../../store/xserverSlice";
import { IEtabActivetedWebService } from "./interface";




const SearchBar = () => {


  const dispatch = useDispatch();
  const { etabActivetedWebService } = useSelector((state: IReduxState) => state.xserverstates);
  console.log("🚀 ~ SearchBar ~ etabActivetedWebService:", etabActivetedWebService)


  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));
  const [search, setSearch] = React.useState("");


  // const filterFunction = () => {
  //   if (search.length === 0) {
  //     dispatch(setFilteredEtabActivetedWebService([...etabActivetedWebService]));
  //   } else {
  //     const result: any = etabActivetedWebService.filter(
  //       (item: IEtabActivetedWebService, index: number) => {
  //         const value: any = `${item.codeEtab}`;
  //         return value.toLowerCase().includes(search.toLowerCase());
  //       }
  //     );
  //     dispatch(setFilteredEtabActivetedWebService(result));
  //   }
  // };


const filterFunction = () => {
  if (search.length === 0) {
    dispatch(setFilteredEtabActivetedWebService([...etabActivetedWebService]));
  } else {
    const result: IEtabActivetedWebService[] = etabActivetedWebService.filter(
      (item: IEtabActivetedWebService) => {
        const term = search.toLowerCase();

        return (
          item.codeEtab?.toLowerCase().includes(term) ||
          item.anneeScolaire?.toLowerCase().includes(term) ||
          item.idService?.toLowerCase().includes(term)
        );
      }
    );

    dispatch(setFilteredEtabActivetedWebService(result));
  }
};


  React.useEffect(() => {
    filterFunction();
  }, [search]);



  return (
    <Box>
      <TextField
        style={{ marginTop: endesssousDeLg ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
